import apiRD from '@/api/supplier/returDelivery';

const defaultState = () => ({
	listRD: [],
	listStatusRD: [],
	returforDelivery: [],
	detailRD: '',
	RDPagination: '',
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	productRD(state){
		if (state.detailRD) {
			return state.detailRD.pdo_detail.map((el) => {
				return {
					product_id: el.pdo_detail_product_id,
					quantity: el.pdo_detail_quantity_received
				}
			})
		}
	}
};

const mutations = {
	setRD(state, data) {
		state.listRD = data.data
		state.RDPagination = data.pagination;
	},
	setReturforDelivery(state, data) {
		state.returforDelivery = data
	},
	setStatusRD(state, data) {
		state.listStatusRD = data
	},
	setDetailRD(state, data) {
		state.detailRD = data
	},
	saveResponse(state, data) {
		state.response = data
	},
	resetResponse(state) {
		state.response = {
			code: '',
			message: ''
		}
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataReturDelivery(state){
		Object.assign(state, defaultState())
	}
};

const actions = {
	getRD({ commit }, params) {
		return new Promise((resolve) => {
			apiRD.getReturDelivery(params).then(({ data: { data } }) => {
				commit('setRD', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setRD', { data: [], pagination: {} });
			});
		});
	},
	getStatusRD({ commit }) {
		return new Promise((resolve) => {
			apiRD.getStatusRD().then(({ data: { data } }) => {
				commit('setStatusRD', data.results );
				resolve()
			}).catch(() => {
				commit('setStatusRD', [] );
			});
		});
	},
	getReturforDelivery({ commit }) {
		apiRD.getReturforDelivery().then(({ data: { data } }) => {
			commit('setReturforDelivery', data.results );
		}).catch(() => {
			commit('setReturforDelivery', [] );
		});
	},
	getDetailRD({ commit, dispatch }, params) {
		apiRD.detailReturDelivery(params).then(({ data: { data } }) => {
			commit('setDetailRD', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailRD', {});
		});
	},
	async exportRD({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiRD.exportReturDelivery(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pengiriman retur'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createRD({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiRD.createReturDelivery(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses pengiriman retur'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};